import { func, object, string } from 'prop-types';
import React from 'react';
import { path } from 'ramda';

import QuestionBlock from './QuestionBlock';
import ControlSteps from '../../OnlineRehabilitation/components/Contents/components/ControlSteps';
import { Col, Row } from 'react-flexbox-grid';
import TextFieldArea from 'components/TextFieldArea';
import ActionButton from 'components/ActionButton';
import RehabHeader from './RehabHeader';

const TextInputArea = ({ value, onChange, onSave }) => (
  <Row>
    <Col xs={7}>
      <TextFieldArea editing input={{ value, onChange }} rows={4} style={{ width: '100%' }} />
    </Col>
    <Col xs={5}>
      <Row style={{ marginLeft: '4rem', marginTop: '0.8rem' }}>
        <Col>{onSave && <ActionButton localeId="npView.history.save" onClick={onSave} secondary border />}</Col>
      </Row>
    </Col>
  </Row>
);

TextInputArea.propTypes = {
  value: string,
  onChange: func,
  onSave: func,
};

const Rehab5 = ({ fm, data, dataFinished, commitPutRehab }) => {
  const controlStepsData = {
    currentStatus: path(['currentStatus'], data),
    clearlyWorseStatus: path(['clearlyWorseStatus'], data),
    nearFutureTarget: path(['nearFutureTarget'], data),
    betterStatus: path(['betterStatus'], data),
    clearlyBetterStatus: path(['clearlyBetterStatus'], data),
  };

  const [text, setText] = React.useState(null);

  const savedFeedbackText = path(['neurologistsComments'], dataFinished);
  const feedbackValue = text || savedFeedbackText || '';

  const onChangeText = event => {
    const eventValue = path(['currentTarget', 'value'], event);
    setText(eventValue);
  };

  const onSave =
    savedFeedbackText !== feedbackValue
      ? () => {
          commitPutRehab({ rehab5: { ...data, neurologistsComments: text } });
          setText(null);
        }
      : null;
  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={5} date={data.finished} />

      <QuestionBlock question={fm('onlineRehabilitation.rehab5.1.cognitiveProblems')} answer={data.cognitiveProblems} />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab5.1.cognitiveProblemsFrequency')}
        answer={data.cognitiveProblemsFrequency}
      />

      <QuestionBlock
        question={fm('npView.rehab5.steps')}
        answer={<ControlSteps steps={controlStepsData} fm={fm} cognition />}
      />
      <QuestionBlock
        question={fm('onlineRehabilitation.rehab5.8.header')}
        answer={data.plannedChangesToManageCognitiveProblems}
      />
      <QuestionBlock
        question={fm('npView.rehab5.feedback')}
        answer={<TextInputArea value={feedbackValue} onChange={onChangeText} onSave={onSave} />}
      />
    </React.Fragment>
  );
};

Rehab5.propTypes = {
  fm: func,
  data: object,
  dataFinished: object,
  commitPutRehab: func,
};
export default Rehab5;
